import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=f607f056&scoped=true&"
import script from "./Donations.vue?vue&type=script&lang=js&"
export * from "./Donations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f607f056",
  null
  
)

export default component.exports